import ConsoleApi from "apps/console/enums/consoleApi";
import { getEventSeriesListKey } from "apps/console/modules/client/eventSeries/list/dataloader";
import { QueryClient } from "react-query";
import { useCopies } from "shared/hooks/useCopies";
import { successToast } from "shared/utils/toastNotification";
import { ApiEventSeriesResponse } from "./type";
import { useGetApiData, usePostApiData } from "shared/datalayer";

export function useGetEventSeries(id?: string) {
  return useGetApiData<ApiEventSeriesResponse>(
    ConsoleApi.GET_EVENT_SERIES_BY_ID,
    { pathParams: { id } },
    {
      enabled: Boolean(id)
    }
  );
}

export function useCreateEventSeries() {
  const copies = useCopies();
  return usePostApiData<ApiEventSeriesResponse, FormData>(ConsoleApi.CREATE_EVENT_SERIES, {
    clientOptions: { trimAndRemoveNull: false },
    onSuccess: () => {
      successToast(copies.get("event.series.create.success"));
    }
  });
}

export function useUpdateEventSeries() {
  const copies = useCopies();
  return usePostApiData<ApiEventSeriesResponse, FormData>(ConsoleApi.UPDATE_EVENT_SERIES, {
    clientOptions: {
      trimAndRemoveNull: false
    },
    onSuccess: () => {
      successToast(copies.get("event.series.update.success"));
    }
  });
}

export function updateListWithNewSeries(
  queryClient: QueryClient,
  createdValue: ApiEventSeriesResponse,
  isPlatformUser?: boolean
) {
  queryClient.setQueryData(getEventSeriesListKey(createdValue.clientId, "", isPlatformUser), (data: any) => {
    return [...data, createdValue];
  });
}
